<template>
  <div>
    <v-tooltip v-if="!isUnarchiving" location="bottom">
      <template #activator="{ props }">
        <v-btn
          v-bind="props"
          :disabled="disabled"
          density="comfortable"
          icon="$unarchive"
          variant="text"
          @click="onUnArchiveWorkpackageClick"
        />
      </template>
      <span>{{ $t('actions.unArchive') }}</span>
    </v-tooltip>
    <v-progress-circular v-else indeterminate size="25" width="3" />
  </div>
</template>

<script>
import { capitalize } from 'lodash';
import { mapActions, mapState } from 'pinia';
import entities from '@enums/entities';
import { useContextStore } from '@/stores/context';
import { useWorkpackagesStore } from '@/stores/workpackages';
import { useSnackbarStore } from '@/stores/snackbar';
import { usePermission } from '@/composables/use-permission';

export default {
  props: {
    workpackage: {
      required: true,
      type: Object,
    },
    entity: {
      type: String,
      required: false,
      default: '',
    },
  },
  setup() {
    const { canUnArchiveWorkpackage } = usePermission();
    return { canUnArchiveWorkpackage };
  },
  data() {
    return {
      isUnarchiving: false,
      message: '',
      offset: null,
      pageSize: null,
    };
  },
  computed: {
    ...mapState(useContextStore, ['clientConfig']),
    ...mapState(useWorkpackagesStore, ['archivedWorkpackagesCurrentPage']),
    disabled() {
      return !this.canUnArchiveWorkpackage;
    },
  },
  created() {
    this.message = this.$t(`notifications.unArchive${capitalize(this.entity)}`, {
      name: this.workpackage.name,
    });
    this.pageSize = this.clientConfig.archivedWorpackages.pageSize;
    this.offset = (this.archivedWorkpackagesCurrentPage - 1) * this.pageSize;
  },
  methods: {
    ...mapActions(useWorkpackagesStore, [
      'updateWorkpackage',
      'fetchWorkpackages',
      'setSelectedWorkpackage',
      'fetchArchivedWorkpackages',
    ]),
    ...mapActions(useSnackbarStore, ['showSuccess']),
    async onUnArchiveWorkpackageClick() {
      const shouldGetTemplates = this.entity === entities.template;
      this.isUnarchiving = true;
      await this.updateWorkpackage({
        workpackageId: this.workpackage._id,
        updates: {
          archived: false,
          archiveDate: null,
        },
      });
      this.setSelectedWorkpackage(this.workpackage);
      await Promise.all([
        this.fetchArchivedWorkpackages({
          limit: this.pageSize,
          offset: this.offset,
          shouldGetTemplates,
        }),
        this.fetchWorkpackages(shouldGetTemplates ? { shouldGetTemplates: true } : {}),
      ]);
      this.showSuccess(this.message);
    },
  },
};
</script>
